// Actions
export const CLEAR_USERS = 'COMMUNICATION/COMPOSE/CLEAR_USERS';
export const CLEAR_COMPOSE_PAGE = 'COMMUNICATION/COMPOSE/CLEAR_PAGE';
export const SEARCH_USERS_ERROR = 'COMMUNICATION/COMPOSE/SEARCH_USERS_ERROR';
export const SEARCH_USERS_REQUEST =
  'COMMUNICATION/COMPOSE/SEARCH_USERS_REQUEST';
export const SEARCH_USERS_SUCCESS =
  'COMMUNICATION/COMPOSE/SEARCH_USERS_SUCCESS';
export const SELECT_USER = 'COMMUNICATION/COMPOSE/SELECT_USER';
export const SEND_MESSAGES_REQUEST =
  'COMMUNICATION/COMPOSE/SEND_MESSAGES_REQUEST';
export const SET_TEXT = 'COMMUNICATION/COMPOSE/SET_TEXT';
export const SET_USERS_LOADING = 'COMMUNICATION/COMPOSE/SET_USERS_LOADING';
export const TOGGLE_DELIVERY_METHOD =
  'COMMUNICATION/COMPOSE/TOGGLE_DELIVERY_METHOD';

/*** Action Creators ***/
export const searchUsersRequest = () => ({
  type: SEARCH_USERS_REQUEST
});

export const searchUsersSuccess = (users) => ({
  type: SEARCH_USERS_SUCCESS,
  users
});

export const searchUsersError = (error) => ({
  type: SEARCH_USERS_ERROR,
  error
});

export const clearUsers = () => ({
  type: CLEAR_USERS
});

export const selectUser = (selectedUser) => ({
  type: SELECT_USER,
  selectedUser
});

export const toggleDeliveryMethod = (deliveryMethod) => ({
  type: TOGGLE_DELIVERY_METHOD,
  deliveryMethod
});

export const sendMessagesRequest = () => ({
  type: SEND_MESSAGES_REQUEST
});

export const setText = (field, text) => ({
  type: SET_TEXT,
  field,
  text
});

export const clearComposePage = () => ({
  type: CLEAR_COMPOSE_PAGE
});

export const setUsersLoading = (usersLoading) => ({
  type: SET_USERS_LOADING,
  usersLoading
});

/*** Reducer ***/
export const DEFAULT_STATE = {
  sms: false,
  email: false,
  pushNotification: false,
  usersLoading: false,
  subject: 'No Subject',
  body: '',
  userSearch: '',
  users: [],
  selectedUser: {}
};

export default function ComposeReducer(
  state = DEFAULT_STATE,
  { type, deliveryMethod, field, text, selectedUser, users, usersLoading } = {}
) {
  switch (type) {
    case SET_TEXT:
      return {
        ...state,
        [field]: text
      };
    case SET_USERS_LOADING:
      return {
        ...state,
        usersLoading
      };
    case SEARCH_USERS_SUCCESS:
      return {
        ...state,
        users
      };
    case CLEAR_USERS:
      return {
        ...state,
        users: []
      };
    case SELECT_USER:
      return {
        ...state,
        selectedUser
      };
    case TOGGLE_DELIVERY_METHOD:
      return {
        ...state,
        [deliveryMethod]: !state[deliveryMethod]
      };
    case CLEAR_COMPOSE_PAGE:
      return DEFAULT_STATE;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/communication/compose/composeActions.js